import { render, staticRenderFns } from "./NewsGroup.vue?vue&type=template&id=0d725263&scoped=true&"
import script from "./NewsGroup.vue?vue&type=script&lang=ts&"
export * from "./NewsGroup.vue?vue&type=script&lang=ts&"
import style0 from "./NewsGroup.vue?vue&type=style&index=0&id=0d725263&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d725263",
  null
  
)

export default component.exports